import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { returnErrors } from "../actions/errorAction";
import { submitBidFailure, submitBidSuccess } from "../actions/submitBidAction";

const getLoginResult = (state) => state.loginReducer.loginResult;

function* asyncSubmitBidPriceSaga(action){
    try{
        const loginResult = yield select(getLoginResult);
        const accessToken = loginResult?.data?.auth_token?.access_token;

        let resBidSubmit = yield call(_api.submitBidApi,{
            reqBid: {
                ...action.payload.reqBid,
                accessToken: accessToken
            },
        })
        yield put(submitBidSuccess({resBidSubmit}))
    }catch(e){
        yield put(submitBidFailure({error:e}))
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* submitBidPriceSaga(){
    yield takeLatest(types.SUBMIT_BID_REQUEST,asyncSubmitBidPriceSaga)
}
